import classNames from 'classnames';
import React, { forwardRef, } from 'react';
import { defaultTextRender, progressBackgroundColor, progressiveColor, statusColor, } from './utils';
const CircleProgress = (props, ref) => {
    const { prefix = 'cn-ui-m-', percent = 0, color, size = 'medium', backgroundColor, progressive = false, state = 'normal', className, rtl, textRender = defaultTextRender, ...others } = props;
    const progressiveColorEnabled = () => {
        if (progressive) {
            return progressiveColor(percent);
        }
        return color || statusColor(state);
    };
    const style = {
        '--percent': props.percent.toString(),
        '--fill-color': progressiveColorEnabled(),
        '--track-color': progressBackgroundColor(backgroundColor),
    };
    return (React.createElement("div", { ...others, ref: ref, className: classNames(`${prefix}progress`, `${prefix}progress-circle--${size}`, `${prefix}progress-circle`, className) },
        React.createElement("div", { className: `${prefix}progress-circle-content`, style: style },
            React.createElement("svg", { className: `${prefix}progress-circle-svg` },
                React.createElement("circle", { className: `${prefix}progress-circle-track`, fill: "transparent" }),
                React.createElement("circle", { className: `${prefix}progress-circle-fill`, fill: "transparent" })),
            React.createElement("div", { className: `${prefix}progress-circle-info` }, textRender(percent, { rtl })))));
};
export default forwardRef(CircleProgress);
